import React from 'react'

import i18n from 'translations'

export const ValidateCertificate = [
  {
    name: i18n.t('users:certificate'),
    component: React.lazy(() => import('../../modules/public/ValidateCertificate')),
    path: '/validate_certificate/:enrollmentId',
    guards: [],
  },
]
